<script lang="ts" module>
	import { cn, tv, type VariantProps } from 'tailwind-variants'

	export const inputGroupAddonVariants = tv({
		base: "h-auto gap-2 py-1.5 text-sm font-medium text-muted-foreground group-data-[disabled=true]/input-group:opacity-50 [&>kbd]:rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-4 flex cursor-text items-center justify-center select-none",
		variants: {
			align: {
				'inline-start': 'pl-2 has-[>button]:ml-[-0.3rem] has-[>kbd]:ml-[-0.15rem] order-first',
				'inline-end': 'pr-2 has-[>button]:mr-[-0.3rem] has-[>kbd]:mr-[-0.15rem] order-last',
				'block-start':
					'px-2.5 pt-2 group-has-[>input]/input-group:pt-2 [.border-b]:pb-2 order-first w-full justify-start',
				'block-end':
					'px-2.5 pb-2 group-has-[>input]/input-group:pb-2 [.border-t]:pt-2 order-last w-full justify-start',
			},
		},
		defaultVariants: {
			align: 'inline-start',
		},
	})

	export type InputGroupAddonAlign = VariantProps<typeof inputGroupAddonVariants>['align']
</script>

<script lang="ts">
	import type { WithElementRef } from 'bits-ui'
	import type { HTMLAttributes } from 'svelte/elements'

	let {
		ref = $bindable(null),
		class: className,
		children,
		align = 'inline-start',
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLDivElement>> & {
		align?: InputGroupAddonAlign
	} = $props()
</script>

<div
	bind:this={ref}
	class={cn(inputGroupAddonVariants({ align }), className)}
	data-align={align}
	data-slot="input-group-addon"
	onclick={e => {
		if ((e.target as HTMLElement).closest('button')) {
			return
		}
		e.currentTarget.parentElement?.querySelector('input')?.focus()
	}}
	role="group"
	{...restProps}
>
	{@render children?.()}
</div>
